import { Component, Inject, OnInit, TemplateRef, Type } from '@angular/core';
import { CDSMask } from '@app/utils/cds-mask';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';
import { MinhaAgendaTransferenciaRetorno } from '@app/models/minha-agenda-transferencia-retorno';
import { MinhaAgendaTransferenciaPesquisa } from '@app/models/minha-agenda-transferencia-pesquisa';
import { ToastrService } from 'ngx-toastr';
import { MinhaAgendaTransferenciaRetornoAgrupada } from './minha-agenda-transferencia-retorno-agrupada';
import { UsuarioService } from '@app/services/usuario.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { MinhaAgenda } from '@app/models/minha-agenda';

@Component({
  selector: 'app-transferencia-agenda',
  templateUrl: './transferencia-agenda.component.html',
  styleUrls: ['./transferencia-agenda.component.scss']
})
export class TransferenciaAgendaComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  pesquisaFiltro: MinhaAgendaTransferenciaPesquisa;
  usuarioLogadoId: number;
  lstAdvogados: IdDescricao[];
  modalRef: BsModalRef;
  lstMinhaAgendaAgrupada: MinhaAgendaTransferenciaRetornoAgrupada[] = [];

  // variaveis de controle
  id = 0;
  agendaId = 0;
  aguardandoSolicitacao = false;

  constructor (
    private minhaAgendaService: MinhaAgendaService,
    private usuarioService: UsuarioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
  ) 
  {
    this.pesquisaFiltro = new MinhaAgendaTransferenciaPesquisa();
    this.pesquisaFiltro.ParticipanteId = 0;
  }

  ngOnInit() {
    this.usuarioService.obterUsuarioLogado().toPromise()
      .then(usuarioLogado => {
        this.usuarioLogadoId = usuarioLogado;
  
        this.validarLogado(this.usuarioLogadoId).then(validarLogado => {
          if (validarLogado) {
            this.pesquisaFiltro.ParticipanteId = usuarioLogado;    
          }
          this.pesquisar();
        });
      });
  }
   

  pesquisar() {
    this.aguardandoSolicitacao = true;
    this.minhaAgendaService.obterMinhaAgendaTransferencia(this.pesquisaFiltro).toPromise().then(agendas => {
      if (agendas?.length < 1) {
        this.toastr.info('Busca não encontrou resultados!');
        this.aguardandoSolicitacao = false;
        return;
      }
      this.lstMinhaAgendaAgrupada = this.agruparAgendas(agendas);
      this.aguardandoSolicitacao = false;
    },
    () => {
      this.toastr.warning("Realize a pesquisa novamente.");
      this.aguardandoSolicitacao = false;
    });
  }
  async validarLogado(usuarioLogadoId: number): Promise<boolean> {
    const dadosConsulta: IdDescricao[] = await this.consultasService.consultar('ADVOGADO_NOMEFANTASIA_E_APELIDO').toPromise();
    this.lstAdvogados = dadosConsulta;
  
    const advogadoEncontrado = this.lstAdvogados.find(adv => adv.Id === usuarioLogadoId);
      return !!advogadoEncontrado;
  }
  
  


  copiarAgenda(agendaId: number) {
    this.aguardandoSolicitacao = true;
    this.minhaAgendaService.obterPorId(agendaId).toPromise().then((data) => {
      this.gravarNovaAgenda(data);
    });
  }

  gravarNovaAgenda(novaAgenda: MinhaAgenda) {
    novaAgenda.Id = 0;
    this.minhaAgendaService.gravar(novaAgenda).toPromise().then((data) => {
      this.pesquisar();
      this.aguardandoSolicitacao = false;
    });
  }

  alteraAgenda(agendaId: number, id: number) {
    this.minhaAgendaService.alterarUsuarioMinhaAgendaTransferencia(agendaId, id).subscribe(data => {
      this.toastr.success('Sucesso ao alterar usuário da agenda', 'Notificação!');
      this.pesquisar();
    });
  }

  openModal(agendaId: number, id: any, template: TemplateRef<any>) {
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, modalOptions);
    this.agendaId = agendaId;
    this.id = id as number;

  }

  confirm(): void {
    this.alteraAgenda(this.agendaId, this.id);
    this.modalRef.hide();
  }

  decline(): void {
    this.toastr.warning('Alteração de usuário cancelada', 'Notificação!');
    this.pesquisar();
    this.modalRef.hide();
  }

  private agruparAgendas(lstMinhaAgenda: MinhaAgendaTransferenciaRetorno[]): MinhaAgendaTransferenciaRetornoAgrupada[] {

    const datas = lstMinhaAgenda.map(minhaAgenda => {
      return Object({ Dia: minhaAgenda.Data, DiaDaSemana: minhaAgenda.DiaDaSemana })
    });
    
    const datasUnicas = this.getDatasUnicas(datas);

    return datasUnicas.map(data => {
      return {
        Data: data.Dia,
        DiaDaSemana: data.DiaDaSemana,
        lstMinhaAgenda: lstMinhaAgenda.filter(x => x.Data === data.Dia)
      }
    })
  }

  private getDatasUnicas(datas: { Dia: string, DiaDaSemana: string }[]): { Dia: string, DiaDaSemana: string }[] {

    const datasAsString = datas.map(d => JSON.stringify(d));
    const datasUnicasAsString = [ ...new Set(datasAsString) ];
    
    return datasUnicasAsString.map(d => {
      const dObj = JSON.parse(d);
      return {
        Dia: dObj.Dia,
        DiaDaSemana: dObj.DiaDaSemana
      }
    });

  }
}
